import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	disabled: {
		opacity: 0.5
	}
});
